import { SvgIcon, SvgIconProps } from "@mui/material";

export const TrendingDownIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24" stroke="none">
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M20.67 9.00021C20.67 9.19021 20.6 9.38021 20.45 9.53021L13.93 16.0502C12.87 17.1102 11.13 17.1102 10.07 16.0502L3.55002 9.53022C3.26002 9.24022 3.26002 8.76022 3.55002 8.47022C3.84002 8.18022 4.32002 8.18022 4.61002 8.47022L11.13 14.9902C11.61 15.4702 12.39 15.4702 12.87 14.9902L19.39 8.47022C19.68 8.18022 20.16 8.18022 20.45 8.47022C20.59 8.62021 20.67 8.81022 20.67 9.00021Z"
      fill="currentColor"
    />
  </SvgIcon>
);
